export default __webpack_public_path__ + "static/media/downIcon.89bd6b1f.svg";